<template>
  <v-layout column>
    <v-flex>
      <v-card
        color="white"
        class="mb-1 elevation-1"
      >
        <v-layout column>
          <v-flex xs12>
            <v-layout>
              <v-card-title
                class="title py-0 px-2"
                style="height: 60px"
              >
                {{ this.title }}
              </v-card-title>

              <v-divider
                v-if="!disableAdding"
                class="mx-2"
                style="height: 50px"
                inset
                vertical
              />

              <v-btn
                v-if="!disableAdding"
                :to="(addRoute) ? addRoute : { path: `/${this.resource}/0` }"
                color="primary"
                dark
                small
                class="my-3 mx-2"
              >
                Добавить
              </v-btn>
              <v-btn
                v-if="!disableAdding && addStepsRoute"
                :to="addStepsRoute"
                color="primary"
                dark
                small
                class="my-3 mx-2"
              >
                Добавить (Шаги)
              </v-btn>
              <DataFilter
                v-model="dataListFilter"
                :resource="this.resource"
                :activated-filter="activatedFilter"
                :role-id="roleId"
                @filterList="savedFilters"
                @input="getItems"
                @change="activate"
              />

              <v-spacer />

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    small
                    icon
                    color="grey"
                    class="my-3"
                    @click="downloadOutputForm()"
                    v-on="on"
                  >
                    <v-icon>grid_on</v-icon>
                  </v-btn>
                </template>
                <span>Экспорт в Excel</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-dialog
                    v-model="columnsDialog"
                    width="500"
                  >
                    <v-btn
                      slot="activator"
                      fab
                      flat
                      small
                      color="grey"
                      class="mt-2"
                      v-on="on"
                    >
                      <v-icon>build</v-icon>
                    </v-btn>

                    <v-card>
                      <v-card-text>
                        <v-layout
                          row
                          wrap
                        >
                          <v-flex
                            v-for="(column, index) in columnsSettings"
                            :key="column.name"
                            xs12
                          >
                            <v-layout row>
                              <v-switch
                                v-model="column.visible"
                                color="primary"
                                class="mt-0"
                                hide-details
                                :label="column.title"
                              />
                              <v-spacer />
                              <v-btn
                                fab
                                flat
                                small
                                @click="moveColumnUp(index)"
                              >
                                <v-icon>keyboard_arrow_up</v-icon>
                              </v-btn>
                              <v-btn
                                fab
                                flat
                                small
                                @click="moveColumnDown(index)"
                              >
                                <v-icon>keyboard_arrow_down</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-btn
                        small
                        color="primary"
                        @click="applyColumnSettings"
                      >
                        Применить
                      </v-btn>
                      <v-btn
                        small
                        @click="saveColumnSettings"
                      >
                        Сохранить
                      </v-btn>
                      <v-btn
                        small
                        @click="columnsDialog = false"
                      >
                        Отмена
                      </v-btn>
                    </v-card>
                  </v-dialog>
                </template>
                <span>Настройки</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            align-self-start
          >
            <v-layout class="my-0">
              <SwitchFilter
                :resource="this.resource"
                :activated="activatedFilter"
                :saved-filters="filtersList"
                @change="activate"
              />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex>
      <v-data-table
        :items="items"
        :headers="headers"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :rows-per-page-items="[13]"
        hide-actions
        class="elevation-1 mb-1 table-striped"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <tr class="text-xs-left px-3">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :style="{minWidth: header.width ? `${header.width}px` : 'auto', whiteSpace: header.width ? 'normal' : 'nowrap' }"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template
          slot="items"
          slot-scope="props"
        >
          <tr :class="{'red lighten-4':props.item.isRemoved, 'yellow lighten-4':props.item.hasOwnProperty('isConfirmed') && props.item.isConfirmed === false }">
            <td
              v-for="column in visibleColumns"
              :key="column.name"
              class="pl-3 pr-0 py-1 clickable-row"
              @click="$router.push( rowTo ? {name: rowTo, params:{id:props.item.id} } : {path: `/${props.item.resource}/${props.item.id}`})"
            >
              <span v-if="isDate(column.name) || column.type === 'date'">{{ props.item[column.name] ? moment(props.item[column.name]).format('DD.MM.YY') : "" }}</span>
              <span v-else-if="column.type === 'decimal' || column.type === 'int'">{{ $options.filters.separateDigits(
                props.item[column.name].toFixed(column.scale).replace(".", ",")
              ) }}
              </span>
              <span v-else-if="column.name === 'phone'">{{ props.item[column.name]?`+${props.item[column.name]}`:"" }}</span>
              <a
                v-else-if="column.isEditLink || column.name === 'id'"
                @click="$router.push({path:`/${props.item.resource}/${props.item.id}`})"
              >{{ props.item[column.name] }}</a>
              <v-icon
                v-else-if="column.type === 'flag'"
                color="green"
              >
                {{ props.item[column.name] ? "done" : "" }}
              </v-icon>
              <span v-else-if="column.type === 'bool'">
                {{ props.item[column.name] ? (column.trueTitle ? column.trueTitle : "Да") : (column.falseTitle ? column.falseTitle : "Нет") }}
              </span>
              <span v-else-if="column.type === 'text-array'">
                {{ props.item[column.name] && props.item[column.name].length>0 ? props.item[column.name].join('; ') : "" }}
              </span>
              <span v-else>{{ props.item[column.name] }}</span>
            </td>
            <td class="text-xs-right pa-2">
              <v-icon @click="$router.push({path:`/${props.item.resource}/${props.item.id}`})">
                edit
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex class="text-xs-center">
      <v-pagination
        v-model="pagination.page"
        :length="pages"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import arrayMove from "array-move";
import DataFilter from "./data-list/DataFilter.vue";
import SwitchFilter from "./data-list/SwitchFilter.vue";
import auth from "../auth";
import * as dataListApi from "../backend/dataListApi.js";

export default {
  components: {
    DataFilter,
    SwitchFilter,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    filter: {
      type: Function,
      required: false,
    },
    disableAdding: Boolean,
    addRoute: Object,
    addStepsRoute: Object,
    filterOptions: Object,
    rowTo: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      columnsSettings: [],
      columnsDialog: false,
      loading: false,
      items: [],
      totalItems: 0,
      pagination: {},
      search: "",
      waitSearch: false,
      dataListFilter: null,
      filterParams: "",
      activatedFilter: null,
      filtersList: [],
      roleId: null,
    };
  },
  computed: {
    pages() {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0;
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    headers() {
      const headers = this.visibleColumns.map(c => {
        return {
          text: c.title,
          sortable: false,
          align: "left",
          width: c.width,
        };
      });
      headers.push({ text: "", sortable: false });
      return headers;
    },
    visibleColumns() {
      const visibleColumns = this.columns.filter(
        c => !c.hasOwnProperty("visible") || c.visible,
      );

      visibleColumns.sort((a, b) => {
        let aOrder = 0;
        if (a.hasOwnProperty("order")) {
          aOrder = a.order;
        } else {
          aOrder = this.columns.indexOf(a);
        }

        let bOrder = 0;
        if (b.hasOwnProperty("order")) {
          bOrder = b.order;
        } else {
          bOrder = this.columns.indexOf(b);
        }

        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });

      return visibleColumns;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.columnsSettings && !this.columnSettingsLoading) {
          this.getItems();
        }
      },
      deep: true,
    },
    columns: {
      handler() {
        this.updateColumnSettings();
      },
      deep: true,
    },
  },
  created() {
    this.getColumnSettings();

    if (this.filterOptions) {
      const dataListFilter = {};
      for (const prop in this.filterOptions) {
        dataListFilter[prop] = { ...this.filterOptions[prop] };
        if (prop.type === "decimal" || prop.type === "int") {
          dataListFilter[prop].valueFrom = null;
          dataListFilter[prop].valueTo = null;
        } else {
          dataListFilter[prop].value = null;
        }
      }
      this.dataListFilter = dataListFilter;
    }

    this.roleId = auth.getUser().role.id;
  },
  methods: {
    activate(value) {
      this.activatedFilter = value;
    },
    savedFilters(value) {
      this.filtersList = value;
    },

    async getItemsFromApi() {
      this.loading = true;
      const url = `${this.resource}?page=${this.pagination.page}&pageSize=${
        this.pagination.rowsPerPage
      }`;
      this.filterParams = "";
      if (this.dataListFilter) {
        for (const prop in this.dataListFilter) {
          if (
            this.dataListFilter[prop].type === "decimal" ||
            this.dataListFilter[prop].type === "int" ||
            this.dataListFilter[prop].type === "date"
          ) {
            if (this.dataListFilter[prop].valueFrom) {
              this.filterParams += `&filter.${prop}From=${
                this.dataListFilter[prop].valueFrom
              }`;
            }
            if (this.dataListFilter[prop].valueTo) {
              this.filterParams += `&filter.${prop}To=${
                this.dataListFilter[prop].valueTo
              }`;
            }
          } else if (
            this.dataListFilter[prop].value &&
            this.dataListFilter[prop].type === "bool"
          ) {
            this.filterParams += `&filter.${prop}=${
              this.dataListFilter[prop].value.booleanValue
            }`;
          } else if (
            this.dataListFilter[prop].type === "reference" &&
            this.dataListFilter[prop].value !== null
          ) {
            this.dataListFilter[prop].value.forEach(v => {
              this.filterParams += `&filter.${prop}Ids=${v.id}`;
            });
          } else if (
            this.dataListFilter[prop].type === "enum" &&
            this.dataListFilter[prop].value !== null
          ) {
            this.dataListFilter[prop].value.forEach(v => {
              this.filterParams += `&filter.${prop}=${v.id}`;
            });
          } else {
            if (this.dataListFilter[prop].value) {
              const paramValue = this.dataListFilter[prop].value;
              this.filterParams += `&filter.${prop}=${paramValue}`;
            }
          }
        }
      }
      if (!this.filterParams) {
        this.filterParams = "&filter=null";
      }

      const res = await dataListApi.getDataFromApi(url);
      const items = res.data.Result.map(i => {
        const item = {
          id: i.Id,
          isRemoved: i.IsRemoved,
          isConfirmed: i.IsConfirmed,
        };
        this.visibleColumns.forEach(c => {
          if (c.dataPath) {
            const dataPathSegments = c.dataPath.split(".");
            let value = i;
            dataPathSegments.forEach(s => (value ? (value = value[s]) : ""));
            item[c.name] = value;
          } else if (c.valueFn) {
            item[c.name] = c.valueFn(i);
          } else {
            if (i.hasOwnProperty(c.name)) {
              item[c.name] = i[c.name];
            } else if (i.hasOwnProperty(capitalizeFirstLetter(c.name))) {
              item[c.name] = i[capitalizeFirstLetter(c.name)];
            }
          }
        });
        item.resource = this.resource;
        return item;
      });
      const total = res.data.TotalItems;
      this.loading = false;
      return { items, total };

      function capitalizeFirstLetter(src) {
        return src.charAt(0).toUpperCase() + src.slice(1);
      }
    },
    getItems() {
      return new Promise((resolve, reject) => {
        this.getItemsFromApi()
          .then(data => {
            this.items = data.items;
            this.totalItems = data.total;
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    isDate(columnName) {
      const reg = /date+$/i;
      return reg.test(columnName);
    },
    applyColumnSettings() {
      this.columnsSettings.forEach((cs, index) => {
        const column = this.columns.find(c => c.name === cs.name);
        if (column) {
          this.$set(column, "visible", cs.visible);
          this.$set(column, "order", index);
        }
      });
      this.columnsDialog = false;
    },
    moveColumnUp(index) {
      this.columnsSettings = arrayMove(
        this.columnsSettings,
        index,
        index - 1 > -1 ? index - 1 : 0,
      );
    },
    moveColumnDown(index) {
      this.columnsSettings = arrayMove(this.columnsSettings, index, index + 1);
    },
    applySavedColumnSettings(settings) {
      if (!settings) {
        return;
      }
      settings.forEach(s => {
        const column = this.columns.find(c => c.name === s.name);
        if (column) {
          this.$set(column, "visible", s.visible);
          this.$set(column, "order", s.order);
        }
      });
    },
    updateColumnSettings() {
      this.columnsSettings = this.columns.map(c => {
        return {
          title: c.title,
          name: c.name,
          visible: c.hasOwnProperty("visible") ? c.visible : true,
          order: c.hasOwnProperty("order") ? c.order : 0,
        };
      });

      this.columnsSettings.sort((a, b) => {
        return a.order - b.order;
      });
    },
    async saveColumnSettings() {
      this.applyColumnSettings();
      await dataListApi.saveColumnSettings(this.resource, this.columns);
    },
    async downloadOutputForm() {
      const res = await dataListApi.downloadOutputForm(
        this.resource,
        this.filterParams,
      );
      this.downloadAsExcel(res.data);
    },
    downloadAsExcel(fileData) {
      const blob = new Blob([fileData], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.title + ".xlsx";
      link.click();
    },
    async getColumnSettings() {
      const res = await dataListApi.getColumnSettings(this.resource);
      if (res.data) {
        this.applySavedColumnSettings(JSON.parse(res.data.Settings));
      } else {
        this.updateColumnSettings();
      }
    },
  },
};
</script>

<style>
.clickable-row {
  cursor: pointer;
}
</style>
